import { render, staticRenderFns } from "./TagArrayInput.vue?vue&type=template&id=a761e1ac&scoped=true"
import script from "./TagArrayInput.vue?vue&type=script&lang=js"
export * from "./TagArrayInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a761e1ac",
  null
  
)

export default component.exports